import { VideoSrc } from './youtube';

const VIMEOMATCH_URL =
  /https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/([^\/]*)\/videos\/|album\/(\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/; // eslint-disable-line no-useless-escape
const VIMEO_PREFIX = 'https://player.vimeo.com/video/';

export const isVimeo = (url: string): boolean => VIMEOMATCH_URL.test(url);

export const getVimeoSrc = (url: string): VideoSrc | undefined => {
  try {
    const matches = url.match(VIMEOMATCH_URL);
    const id = matches && matches[3];
    if (id) {
      return {
        srcID: id,
        srcType: 'vimeo',
        url,
      };
    }
    return undefined;
  } catch {
    return undefined;
  }
};

export const getVimeoSrcUrl = (src: string): string | undefined => {
  const videoSrc = getVimeoSrc(src);
  return videoSrc ? `${VIMEO_PREFIX}${videoSrc.srcID}` : undefined;
};
